import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../store';
import { 
  selectNotificationQueue, 
  removeFromNotificationQueue,
  markAchievementAsViewed
} from '../store/slices/achievementsSlice';
import AchievementNotification from '../components/AchievementNotification';
import { Achievement } from '../types/goals';

interface AchievementProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that manages achievement notifications
 * Shows achievement unlock notifications when new achievements are earned
 */
const AchievementProvider: React.FC<AchievementProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const notificationQueue = useSelector(selectNotificationQueue);
  const currentNotification = useRef<Achievement | null>(null);

  useEffect(() => {
    // Process notification queue
    if (notificationQueue.length > 0 && !currentNotification.current) {
      const achievement = notificationQueue[0];
      currentNotification.current = achievement;
      
      // Mark achievement as viewed after showing notification
      dispatch(markAchievementAsViewed(achievement.id));
    }
  }, [notificationQueue, dispatch]);

  const handleNotificationClose = () => {
    if (currentNotification.current) {
      dispatch(removeFromNotificationQueue(currentNotification.current.id));
      currentNotification.current = null;
    }
  };


  return (
    <>
      {children}
      {currentNotification.current && (
        <AchievementNotification
          achievement={currentNotification.current}
          onClose={handleNotificationClose}
        />
      )}
    </>
  );
};

export default AchievementProvider;